import {useNavigate, useParams} from "react-router-dom";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {Card} from "@mui/material";
import Meta from "../common/Meta";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Footer from "../Footer";
import Grid from "@mui/material/Grid";
import {useMaterialUIController} from "../../context";
import {archiveCompanyDiscountCode, getCompanyDiscountCode, getCompanyDiscountCodes} from "../common/api/WebApi";
import MDInput from "../../components/MDInput";
import MDButton from "../../components/MDButton";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import DataTable from "react-data-table-component";
import BootyPagination from "../common/bootyPagination";
import PageLoading from "../common/PageLoading";
import * as pagination from "../common/pagination";
import {formatCurrency, formatDate} from "../common/Utils";
import {getCookie, setCookie} from "../common/appCookie";
import ManageDiscountCodeModal from "../discount/ManageDiscountCodeModal";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import NotificationItem from "../Items/NotificationItem";
import Confirm from "../common/Confirm";
import ManageDiscountCodeTokensModal from "../discount/ManageDiscountCodeTokensModal";


export default function CompanyDiscountCodes(props) {

  let {guid} = useParams();

  const [isNew, setIsNew] = useState(true);
  const [loading, setLoading] = useState(true);

  const [controller] = useMaterialUIController();
  const {darkMode} = controller;

  const navigate = useNavigate();

  const [context, setContext] = useContext(AppContext);

  const [isManagingCode, setIsManagingCode] = useState(false);
  const [isManagingTokens, setIsManagingTokens] = useState(false);

  const [discountCode, setDiscountCode] = useState(null);

  const manageCodeTokens = (code) => {
    getCompanyDiscountCode(code.guid).then(result => {
      setLoading(false);
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setIsManagingTokens(true);
        setDiscountCode(result);
      }
    });
  }

  const manageCode = (code) => {
    setIsManagingCode(true);
    setDiscountCode(code);
  }

  const [discountCodes, setDiscountCodes] = useState([]);
  const [render, setRender] = useState(0);
  const [startPage, setStartPage] = useState(0);
  const [templates, setTemplates] = useState([]);
  const [sortOrder, setSortOrder] = useState(1);
  const [sortDir, setSortDir] = useState('asc');
  const [PaginationOptions, setPaginationOptions] = useState(pagination._PaginationOptions);
  const [searchCriteria, setSearchCriteria] = useState();

  useEffect(() => {
    getDiscountCodes();
  }, []);

  const getDiscountCodes = async () => {
    setLoading(true);
    getCompanyDiscountCodes().then(result => {
      setLoading(false);
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setDiscountCodes(result);
      }
    });
  }


  const handleSort = (column, sortDirection) => {

    setSortOrder(column.id);
    setSortDir(sortDirection);
    setCookie('DISCOUNT_CODE', column.id);
    setCookie('DISCOUNT_CODE_DIR', sortDirection);

    setRender(render + 1);

  };
  const [confirmation, setConfirmation] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [archiveCode, setArchiveCode] = useState(false);

  const [saving, setSaving] = useState(false);
  const deleteDiscountCode = ()=> {
    setLoading(true);
    setSaving(true);
    archiveCompanyDiscountCode(discountCode).then(result => {
      setSaving(false);
      setLoading(false);
      setDiscountCode(null);
      setArchiveCode(false);
      setConfirmation(null);
      setShowConfirm(false);

      getDiscountCodes();
    });
  }

  const preDeleteCode = (item) => {
    let confirmation = {
      title: 'Archive Code?',
      message: 'Archive ' + item.name + '?',
      entity: item
    }
    setConfirmation(confirmation);
    setShowConfirm(true);
    setDiscountCode(item);
  };

  const Actions = ({item}) => {

    return (<PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
            <MDButton
              variant="outlined"
              color="secondary"
              size="small"
              circular
              iconOnly
            >
              <Icon>more_horiz</Icon>
            </MDButton>
          </span>
          <Menu {...bindMenu(popupState)}>

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageCode(item)
              }} icon={<Icon>edit</Icon>} title="Edit"/>

            {item.multiple && <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageCodeTokens(item)
              }} icon={<Icon>rule</Icon>} title="Edit Code Tokens"/>}

              <NotificationItem onClick={(e) => {
                popupState.close();
                preDeleteCode(item);
              }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  const _columns = [
    {
      name: <span className='th'>Name</span>,
      id: 1,
      selector: row => row.name,
      cell: row => {
        return <span>{row.name}</span>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Create Date</span>,
      id: 2,
      selector: row => row.createDate,
      cell: row => {
        return <span>{formatDate(row.createDate)}</span>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Modify Date</span>,
      id: 3,
      selector: row => row.modifyDate,
      cell: row => {
        return <span>{formatDate(row.modifyDate)}</span>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Code</span>,
      id: 4,
      selector: row => row.code,
      cell: row => {
        return <span>{row.multiple ? 'Multiple' : row.code}</span>;
      },
      sortable: true,
    },
    {
      name: <span className='th' align={'right'}>Discount</span>,
      id: 7,
      selector: row => row.value,
      right: true,
      cell: row => {
        return <span>{row.discountCodeType.id === 1 ? formatCurrency(row.value) : row.value + '%'}</span>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Expiration Date</span>,
      id: 6,
      selector: row => row.expirationDate,
      cell: row => {
        return <span>{row.expirationDate ? formatDate(row.expirationDate) : ''}</span>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Unlimited</span>,
      id: 8,
      selector: row => row.unlimited,
      cell: row => {
        return <span>{row.unlimited ? 'Yes' : 'No'}</span>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Actions</span>,
      id: 5,
      right: true,
      selector: row => row.guid,
      cell: row => {
        return  <Actions item={row}/>
      },
      sortable: false,
    },
  ];

  const [columns, setColumns] = useState(_columns);
  const handleSearchChange = (e) => {
    setSearchCriteria(e.target.value);
  }

  const filteredResults = (items) => {
    if (!searchCriteria || searchCriteria.length === 0) {
      return items;
    }
    let _items = [];
    for (let j in items) {
      let nameCrit = items[j]?.name.toLowerCase();
      let match = nameCrit.match(searchCriteria.toLowerCase());
      if (match && match.length > 0) {
        _items.push(items[j]);
      }
    }
    return _items;
  }

  const handlePageChange = (selector, page) => {
    setStartPage(selector);
  };

  return (
    <>
      <DashboardLayout>
        <Meta pageTitle={'Company Discount Codes'}/>
        <ContextSearchNavbar title="Company Discount Codes"/>

        <MDBox mt={4}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <MDBox pb={3}>
                <MDBox mb={3}>
                  <Card>
                    <MDBox p={3} lineHeight={1}>

                      <MDButton
                        onClick={() => {
                          manageCode(null);
                        }}
                        color="info"
                        size="small"
                        className="pull-right"
                        variant="contained">New Discount Code</MDButton>

                      <h5 fontWeight="regular">
                        Your Discount Codes
                      </h5>
                      <Grid container justifyContent={'flex-end'} mt={2}>
                        <Grid item xs={12} sm={4}>
                          <MDInput type="text"
                                   variant="outlined"
                                   value={searchCriteria || ''}
                                   onChange={handleSearchChange}
                                   className="form-control mb-2" id="searchCriteria" aria-describedby="searchCriteria"
                                   label="Search"/>
                        </Grid>
                      </Grid>
                    </MDBox>
                    {!loading && <DataTable
                      striped
                      columns={columns}
                      keyField={'guid'}
                      data={filteredResults(discountCodes)}
                      onSort={handleSort}
                      highlightOnHover
                      pagination
                      paginationPerPage={20}
                      paginationComponent={BootyPagination}
                      onChangePage={handlePageChange}
                      progressPending={loading}
                      defaultSortFieldId={getCookie('DISCOUNT_CODE') || 1}
                      defaultSortAsc={getCookie('DISCOUNT_CODE_DIR') === 'desc' ? false : true}
                      paginationComponentOptions={PaginationOptions}
                    />}
                  </Card>
                </MDBox>

                {loading && <PageLoading/>}

              </MDBox>
            </Grid>
          </Grid>
        </MDBox>


        <Footer mt={5}/>

      </DashboardLayout>

      {
        confirmation && <Confirm confirmation={confirmation}
                                 show={showConfirm}
                                 saving={saving}
                                 handleSave={()=> {
                                   setShowConfirm(false);
                                 }}
                                 handleConfirm={deleteDiscountCode}
                                 handleClose={()=>{
                                   setConfirmation(null);
                                   setShowConfirm(false);
                                 }}/>
      }


      {isManagingCode && <ManageDiscountCodeModal
        handleSave={(data) => {
          setDiscountCode(null);
          setIsManagingCode(false);
          getDiscountCodes();
        }}
        show={isManagingCode} discountCode={discountCode} handleClose={() => {
        setIsManagingCode(false);
        setDiscountCode(null);
      }}/>}

      {isManagingTokens && <ManageDiscountCodeTokensModal
        handleSave={(data) => {
          setDiscountCode(null);
          setIsManagingTokens(false);
          getDiscountCodes();
        }}
        show={isManagingTokens} discountCode={discountCode} handleClose={() => {
        setIsManagingTokens(false);
        setDiscountCode(null);
      }}/>}
    </>
  );
}